import { logError } from '@util/logger'
import { get } from 'lodash-es'

export const toOffsetPaginatedList = <E, F extends string | never = never>(
    data: Json,
    dataMapper: Mapper<E>
): TOffsetPaginatedList<E> | TOffsetPaginatedList<E, F> => {
    const base = {
        total: get(data, 'total', 0),
        limit: get(data, 'limit'),
        offset: get(data, 'offset'),
        paginationType: 'offset',
        entries: get(data, '_embedded.self', [])
            .map((entry: Json) => {
                try {
                    return dataMapper(entry)
                } catch (e) {
                    logError(e, {
                        dev: 'console',
                        localhost: 'console',
                        test: 'console',
                        metadata: {
                            description: `Custom mapper failed for OffsetPaginatedList`,
                            dataMapper,
                            allData: data,
                            failedEntry: entry,
                        },
                    })

                    return
                }
            })
            // Remove any entries where the dataMapper threw an exception
            .filter(Boolean),
    }

    const f = get(data, '_embedded.facets', false)

    if (f) {
        return {
            ...base,
            facets: f,
        } as TOffsetPaginatedList<E, F>
    }

    return base as TOffsetPaginatedList<E>
}
